import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { hideNotification } from '../../store/actions/notification';
import DashboardLayout from '../layout/Dashboard';
import { Messages } from "../../components/layout/Messages/Messages";
import { AppointmentsCalendar } from '../../components/pages/appointments/AppointmentsCalendar';
import { SettingsAppointments } from '../../components/pages/appointments/actionButtons/SettingsAppointments';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './Appointments.scss';

function AppointmentsComponent(props) {
  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title" />}
      workspace
      {...props}
    >
      <PageWorkspace className="appointments-workspace">
        <PageHeader
          actions={<SettingsAppointments/>}
          title={<FormattedMessage id="pages.appointments.title"/>}
        />
        <div className="appointments-notifications">
          <Messages/>
        </div>
        <PageSurface className="appointments-surface">
          <AppointmentsCalendar/>
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  )
}

const Appointments = connect(null, { hideNotification })(AppointmentsComponent);

export { Appointments, AppointmentsComponent };
